import { useState } from 'react';

const T = {
  bg:'#06060d',s1:'#0d0c18',s2:'#12111e',s3:'#181628',
  border:'rgba(255,255,255,0.07)',border2:'rgba(255,255,255,0.13)',
  gold:'#d4a853',gold2:'#f0c878',cream:'#f0ead8',
  text2:'#9890b0',text3:'#55506a',teal:'#1a8a76',purple:'#8b5cf6',
};
const Btn = ({children,onClick,gold,small,style={}}) => (<button onClick={onClick} style={{background:gold?`linear-gradient(135deg,${T.gold},${T.gold2})`:T.s3,border:gold?'none':`1px solid ${T.border2}`,borderRadius:8,padding:small?'4px 10px':'0.55rem 1rem',color:gold?T.bg:T.cream,fontSize:small?11:13,fontWeight:gold?700:400,cursor:'pointer',fontFamily:'inherit',...style}}>{children}</button>);

const PROGRAMS = [
  {icon:'🎓',name:'Creative Workshops & Residencies',desc:'Funded workshops, intensives, and artist residency programs providing working space, mentorship, and resources to creative professionals at all stages of their career.',action:'Apply for a Residency'},
  {icon:'🏛',name:'Third Space Initiative',desc:'Community-accessible creative spaces and programming that serve as a meeting ground between professional artists and the communities they live and work in.',action:'Find a Space Near You'},
  {icon:'🌱',name:'Starving Artist Fund',desc:'Direct financial assistance — cash grants, emergency relief, and subsidized access to tools and resources — for creative professionals experiencing financial hardship. Includes subsidized or free access to Artizan Artist Pro for qualifying individuals.',action:'Apply for Assistance'},
];

const TIERS = [
  {name:'Call',range:'Any amount',color:T.text3},
  {name:'Understudy',range:'$10–$49',color:T.text2},
  {name:'Company Member',range:'$50–$199',color:T.cream},
  {name:'Resident',range:'$200–$499',color:T.gold},
  {name:'Benefactor',range:'$500–$999',color:T.gold2},
  {name:'Founding Patron',range:'$1,000+',color:T.purple},
];

export default function CraftCommons() {
  const [amount,setAmount] = useState('');
  const [donated,setDonated] = useState(false);
  const [activeProgram,setActiveProgram] = useState(null);

  const donate = () => {
    if(!amount||parseFloat(amount)<=0) return;
    setDonated(true); setTimeout(()=>setDonated(false),3000); setAmount('');
  };

  const getTier = (amt) => {
    const n=parseFloat(amt);
    if(n>=1000) return TIERS[5]; if(n>=500) return TIERS[4];
    if(n>=200) return TIERS[3]; if(n>=50) return TIERS[2];
    if(n>=10) return TIERS[1]; return TIERS[0];
  };
  const tier = amount?getTier(amount):null;

  return (
    <div style={{padding:20,fontFamily:"'DM Sans','Jost',sans-serif",maxWidth:700,margin:'0 auto'}}>
      <div style={{textAlign:'center',marginBottom:28}}>
        <div style={{fontSize:32,marginBottom:8}}>⧫</div>
        <div style={{fontSize:24,fontWeight:700,color:T.gold,marginBottom:6}}>The Craft Commons Foundation</div>
        <div style={{fontSize:13,color:T.text2,lineHeight:1.8,maxWidth:500,margin:'0 auto'}}>A nonprofit organization built to ensure that financial hardship never stands between a creative person and their craft. Every dollar goes directly to the artists who need it most.</div>
        <div style={{fontSize:11,color:T.text3,marginTop:8}}>501(c)(3) pending · Transparency report published annually · artizancraft.app/foundation</div>
      </div>

      <div style={{marginBottom:24}}>
        <div style={{fontSize:11,color:T.gold,fontWeight:700,textTransform:'uppercase',letterSpacing:2,marginBottom:12}}>Three Programs</div>
        {PROGRAMS.map((p,i)=>(
          <div key={i} onClick={()=>setActiveProgram(activeProgram===i?null:i)} style={{background:T.s2,border:`1px solid ${activeProgram===i?T.gold:T.border}`,borderRadius:12,padding:'14px 16px',marginBottom:10,cursor:'pointer'}}>
            <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:activeProgram===i?10:0}}>
              <span style={{fontSize:20}}>{p.icon}</span>
              <div style={{flex:1}}><div style={{fontSize:13,fontWeight:700,color:T.cream}}>{p.name}</div></div>
              <div style={{fontSize:11,color:T.text3}}>{activeProgram===i?'▲':'▼'}</div>
            </div>
            {activeProgram===i&&(
              <div>
                <div style={{fontSize:12,color:T.text2,lineHeight:1.7,marginBottom:10}}>{p.desc}</div>
                <Btn small gold onClick={e=>e.stopPropagation()}>{p.action}</Btn>
              </div>
            )}
          </div>
        ))}
      </div>

      <div style={{background:T.s2,border:`1px solid ${T.border2}`,borderRadius:12,padding:20,marginBottom:20}}>
        <div style={{fontSize:13,fontWeight:700,color:T.gold,marginBottom:4}}>Support the Foundation</div>
        <div style={{fontSize:11,color:T.text2,marginBottom:14}}>100% of donations go directly to Foundation programs. Artizan takes no cut of Foundation donations.</div>
        <div style={{display:'flex',gap:8,marginBottom:10,flexWrap:'wrap'}}>
          {['5','10','25','50','100'].map(a=>(
            <button key={a} onClick={()=>setAmount(a)} style={{background:amount===a?T.gold:T.s3,color:amount===a?T.bg:T.text2,border:`1px solid ${amount===a?T.gold:T.border2}`,borderRadius:8,padding:'6px 12px',fontSize:12,cursor:'pointer',fontFamily:'inherit',fontWeight:amount===a?700:400}}>${a}</button>
          ))}
          <input value={amount} onChange={e=>setAmount(e.target.value)} style={{flex:1,background:T.s3,border:`1px solid ${T.border2}`,borderRadius:8,padding:'6px 12px',color:T.cream,fontSize:12,outline:'none',fontFamily:'inherit',minWidth:100}} placeholder="Custom amount"/>
        </div>
        {tier&&<div style={{fontSize:11,color:tier.color,marginBottom:10}}>This puts you at: <strong>{tier.name}</strong> ({tier.range}) — recognized on your Artizan profile</div>}
        {donated?<div style={{textAlign:'center',color:T.teal,fontSize:13,fontWeight:700,padding:'8px'}}>✓ Thank you for supporting the Foundation.</div>:<Btn gold onClick={donate} style={{width:'100%'}}>Donate ${amount||'...'} to Craft Commons</Btn>}
      </div>

      <div>
        <div style={{fontSize:11,color:T.gold,fontWeight:700,textTransform:'uppercase',letterSpacing:2,marginBottom:10}}>Donor Recognition</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:8}}>
          {TIERS.map(t=>(
            <div key={t.name} style={{background:T.s2,border:`1px solid ${T.border}`,borderRadius:8,padding:'8px 12px'}}>
              <div style={{fontSize:12,fontWeight:700,color:t.color}}>{t.name}</div>
              <div style={{fontSize:10,color:T.text3,marginTop:2}}>{t.range}</div>
            </div>
          ))}
        </div>
        <div style={{fontSize:10,color:T.text3,textAlign:'center',marginTop:10}}>Recognition displayed on your Artizan profile when opted in. Cumulative lifetime giving.</div>
      </div>
    </div>
  );
}